/** @format */

import { Checkbox } from 'antd';

export default function CustomCheckbox(props) {
	return <Checkbox {...props} />;
}
